"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SimpleDropdown = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(SimpleDropdown, _Component);

  var _super = _createSuper(SimpleDropdown);

  function SimpleDropdown() {
    var _this;

    (0, _classCallCheck2.default)(this, SimpleDropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isOpen: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "hoverTimeout", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "buttonRef", (0, _preact.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "containerRef", (0, _preact.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClickOutside", function (event) {
      if (!_this.props.openOnHover && _this.state.isOpen && _this.containerRef.current) {
        if (!_this.containerRef.current.contains(event.target)) {
          _this.closeDropdown();
        }
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleKeyDown", function (event) {
      var _this$buttonRef$curre;

      if (!_this.state.isOpen) return;

      switch (event.code) {
        case 'Escape':
          _this.closeDropdown();

          (_this$buttonRef$curre = _this.buttonRef.current) === null || _this$buttonRef$curre === void 0 ? void 0 : _this$buttonRef$curre.focus();
          event.preventDefault();
          break;

        case 'Tab':
          _this.closeDropdown();

          break;
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "openDropdown", function () {
      _this.setState({
        isOpen: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "closeDropdown", function () {
      _this.setState({
        isOpen: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleMouseEnter", function () {
      if (_this.props.openOnHover) {
        if (_this.hoverTimeout) clearTimeout(_this.hoverTimeout);

        _this.openDropdown();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleMouseLeave", function () {
      if (_this.props.openOnHover) {
        _this.hoverTimeout = setTimeout(function () {
          return _this.closeDropdown();
        }, 100);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClick", function () {
      if (!_this.props.openOnHover) {
        _this.setState(function (state) {
          return {
            isOpen: !state.isOpen
          };
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleButtonKeyDown", function (event) {
      switch (event.code) {
        case 'Enter':
        case 'Space':
          event.preventDefault();

          _this.setState(function (state) {
            return {
              isOpen: !state.isOpen
            };
          });

          break;

        case 'ArrowDown':
        case 'ArrowUp':
          event.preventDefault();

          _this.openDropdown();

          break;
      }
    });
    return _this;
  }

  (0, _createClass2.default)(SimpleDropdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('keydown', this.handleKeyDown);

      if (!this.props.openOnHover) {
        document.addEventListener('click', this.handleClickOutside);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
      window.removeEventListener('keydown', this.handleKeyDown);
      document.removeEventListener('click', this.handleClickOutside);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          trigger = _this$props.trigger,
          children = _this$props.children,
          className = _this$props.className,
          popupName = _this$props.popupName;
      var isOpen = this.state.isOpen;
      var menuId = "".concat(popupName, "-menu");
      return (// eslint-disable-next-line jsx-a11y/no-static-element-interactions
        (0, _preact.h)("div", {
          ref: this.containerRef,
          className: "dropdown-container",
          onMouseEnter: this.props.openOnHover ? this.handleMouseEnter : undefined,
          onMouseLeave: this.props.openOnHover ? this.handleMouseLeave : undefined
        }, (0, _preact.h)("button", {
          ref: this.buttonRef,
          id: popupName,
          "aria-haspopup": "true",
          "aria-expanded": isOpen,
          "aria-controls": menuId,
          type: "button",
          style: {
            background: 'none',
            border: 'none',
            fontWeight: 'inherit',
            display: 'inline-block',
            padding: 0,
            margin: 0,
            cursor: 'pointer'
          },
          onClick: this.handleClick,
          onKeyDown: this.handleButtonKeyDown
        }, trigger), (0, _preact.h)("ul", {
          id: menuId,
          "aria-labelledby": popupName,
          className: (0, _classnames.default)(className, {
            'is-hidden': !isOpen
          }),
          "aria-hidden": !isOpen
        }, children))
      );
    }
  }]);
  return SimpleDropdown;
}(_preact.Component);

var _default = SimpleDropdown;
exports.default = _default;